// @mui material components
import Container from "@mui/material/Container";
import Card from "@mui/material/Card";
import Box from "@mui/material/Box"; // MUI Box 사용

// Intro Contents
import SlideContents from "./section/SlideContents";
import Counters from "./section/counter/Counters";
import EnergySaveZoneInfo from "./section/EnergySaveZoneInfo";
import History from "./section/History";
import License from "./section/License";
import Direction from "./section/Direction";

function Intro() {
  return (
    <>
      <SlideContents />
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
          zIndex: 2,
        }}
      >
        <Counters />
        {/* 에너지 세이브 존 */}
        <Box id="energy-save-zone" sx={{ paddingTop: "70px", marginTop: "-70px" }}>
          <EnergySaveZoneInfo />
        </Box>
        {/* 연혁 */}
        <Box id="history" sx={{ paddingTop: "70px", marginTop: "-70px" }}>
          <History />
        </Box>
        {/* 지식재산권 및 인증서 */}
        <Box id="license" sx={{ paddingTop: "70px", marginTop: "-70px" }}>
          <License />
        </Box>
        {/* 오시는 길 */}
        <Container id="direction" sx={{ mt: 6 }}>
          <Direction />
        </Container>
      </Card>
    </>
  );
}

export default Intro;
